import { render, staticRenderFns } from "./EditTemplateCours.vue?vue&type=template&id=1d879b54&"
import script from "./EditTemplateCours.vue?vue&type=script&lang=ts&"
export * from "./EditTemplateCours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports